/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset status refers to current source activity performed by an asset.
 *
 */
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus["PRODUCTION"] = "Production";
    AssetStatus["CHARGING"] = "Charging";
    AssetStatus["WARMING"] = "Warming";
    AssetStatus["COOLING"] = "Cooling";
    AssetStatus["HOT_STAND_BY"] = "HotStandBy";
    AssetStatus["COLD_STAND_BY"] = "ColdStandBy";
    AssetStatus["LOW_PRESSURE"] = "Low Pressure";
    AssetStatus["FAULT"] = "Fault";
    AssetStatus["OFF"] = "Off";
})(AssetStatus || (AssetStatus = {}));
